import cx from "classnames";
import React from "react";

import { CLASS_TITLE } from "./constants";

interface PromotionCardTitleProps {
  className?: string;
  children: React.ReactElement;
  [key: string]: any;
}

export const PromotionCardTitle: React.FC<PromotionCardTitleProps> = ({
  className,
  children,
  ...other
}) => {
  const classes = cx(CLASS_TITLE, className);
  return React.cloneElement(children, {
    className: classes,
    ...other,
  } as React.HTMLAttributes<HTMLElement>);
};

PromotionCardTitle.displayName = "PromotionCardTitle";
